module.exports = __webpack_public_path__ + "f3fb898ecbf85a21f2b435e538a31415.pdf";